import React, { useState } from 'react';
import { auth, googleProvider, db } from '../../services/firebaseConnection';
import { signInWithPopup, signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { setDoc, doc, getDoc } from 'firebase/firestore';
import './loginCli.css';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import LogoBarberia from '../../assets/LogoBarbearia.png';


export default function LoginCli() {
  const [googleData, setGoogleData] = useState(null);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isRegistering, setIsRegistering] = useState(false);
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const navigate = useNavigate();

  async function registerWithEmail() {
    if (password !== confirmPassword) {
      alert("As senhas não coincidem!");
      return;
    }
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      const userDoc = doc(db, 'users', user.uid);
      const userData = {
          name: name,
          email: email,
          phone: phone
      };
      await setDoc(userDoc, userData);
      
      alert("Registro concluído com sucesso!");
      navigate('/homeCli');
    } catch (error) {
      if (error.code === 'auth/email-already-in-use') {
        alert("O e-mail fornecido já está em uso. Por favor, tente fazer login ou recuperar sua senha.");
      } else {
        alert(`Erro ao registrar: ${error.message}`);
      }
    }
  }
  

  async function signInWithEmail() {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      alert("Login realizado com sucesso!");
      navigate('/homeCli');
    } catch (error) {
      alert(`Erro ao entrar: ${error.message}`);
    }
  }

  async function signInWithGoogle() {
    try {
      const { user } = await signInWithPopup(auth, googleProvider);
      const userDocRef = doc(db, 'users', user.uid);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        alert("Login com Google realizado com sucesso!");
        navigate('/homeCli');
      } else {
        setGoogleData(user);
        alert("Usuário do Google não registrado. Por favor, complete seu registro.");
      }
    } catch (error) {
      alert(`Erro ao entrar com Google: ${error.message}`);
    }
  }

  async function finalizeRegistration() {
    if (!googleData) {
      alert("Dados do Google não definidos!");
      return;
    }

    const userDoc = doc(db, 'users', googleData.uid);
    const userData = {
      name: googleData.displayName,
      email: googleData.email,
      phone: phone
    };

    try {
      await setDoc(userDoc, userData);
      alert("Registro com Google concluído com sucesso!");
      navigate('/homeCli');
    } catch (error) {
      alert(`Erro ao salvar dados do usuário: ${error.message}\nCódigo: ${error.code}`);
    }
  }

  return (
    <div className="login-container">
    <h1 className="login-title">Corte's curte</h1>
    <div className='box-logo'>      
      <img src={LogoBarberia} alt="Logo" className="logoo" />
      <p>Crie seu cadastro para ter acesso a tela de agendamentos.</p>
    </div>
    <div className="login-box">
      {!googleData ? (
        isRegistering ? (
          <>
            {/* Inputs para registro */}
            <input type="text" className="login-input" placeholder="Nome" value={name} onChange={e => setName(e.target.value)} />
            <input type="email" className="login-input" placeholder="E-mail" value={email} onChange={e => setEmail(e.target.value)} />
            <input type="text" className="login-input" placeholder="Telefone" value={phone} onChange={e => setPhone(e.target.value)} />
            <input type="password" className="login-input" placeholder="Senha" value={password} onChange={e => setPassword(e.target.value)} />
            <input type="password" className="login-input" placeholder="Confirme sua senha" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
            <button className="register-button" onClick={registerWithEmail}>Finalizar registro</button>
            <button className="back-button" onClick={() => setIsRegistering(false)}>Voltar para Login</button>
          </>
        ) : (
          <>
            {/* Inputs para login */}
            <input type="email" className="login-input" placeholder="E-mail" value={email} onChange={e => setEmail(e.target.value)} />
            <input type="password" className="login-input" placeholder="Senha" value={password} onChange={e => setPassword(e.target.value)} />
            <button className="login-button" onClick={signInWithEmail}>Entrar</button>
            <button className="google-button" onClick={signInWithGoogle}>Continuar com Google</button>
            <p className="register-text">Não possui uma conta?</p>
            <button className="register-button" onClick={() => setIsRegistering(true)}>Criar conta</button>
          </>
          )
        ) : (
          <>
            <input type="text" className="login-input" placeholder="Nome" defaultValue={googleData.displayName} readOnly />
            <input type="email" className="login-input" placeholder="E-mail" defaultValue={googleData.email} readOnly />
            <input type="text" className="login-input" placeholder="Telefone" value={phone} onChange={e => setPhone(e.target.value)} />
            <button className="register-button" onClick={finalizeRegistration}>Criar conta</button>
          </>
        )}
      </div>
    </div>
  );
}
